import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';

import { ServiceEx } from '../../../../../../../models/ServicePresets';
import { ReactComponent as CheckIcon } from '../../../../../../../assets/images/ArrowSaveEmail.svg';
import { TextButton, TextButtonClassNames } from '../../../../../../commons/buttons/TextButton';

interface FilmsExSrvProps {
  serviceEx: ServiceEx;
  isBrizTvLogin: boolean;
  isDisabled: boolean;
  isShareStillActive: boolean;
  isCurrentServiceSuspension: boolean;
  handleConnectFilms: () => void;
}

const FilmsExSrv: FC<FilmsExSrvProps> = ({
  serviceEx: { Price, IsConnected, Name },
  isBrizTvLogin,
  isDisabled,
  isShareStillActive,
  isCurrentServiceSuspension,
  handleConnectFilms,
}) => {
  const { t } = useTranslation();

  return (
    <>
      {isBrizTvLogin && !isShareStillActive && !isCurrentServiceSuspension && isCurrentServiceSuspension !== null ? (
        <div className="service-card__info-container__info__additional">
          {Name}
          {IsConnected ? ` (${Price} ${t('services.uahPerMonth')})` : null}:&nbsp;
          {IsConnected ? (
            <span className="active connected-extra">
              {t('common.connected')}&nbsp; <CheckIcon className="icon-check" />
            </span>
          ) : (
            <TextButton
              label={`${t('buttons.addFor')} ${Price} ${t('services.uahPerMonth')}`}
              handleClick={handleConnectFilms}
              className={TextButtonClassNames.PrimaryActive}
              isDisabled={isDisabled}
            />
          )}
        </div>
      ) : null}
    </>
  );
};

export default FilmsExSrv;
